import type { Translation } from '../types.ts';
import type en from '../en/articles.ts';

export default {
    list: {
        title: 'Artikelen',
        newArticle: 'Nieuw artikel',
        searchPlaceholder: 'Zoek op titel, samenvatting of tag…',
        allTags: 'Alle tags',
        empty: 'Geen artikelen gevonden met deze filters.',
        columns: {
            tags: 'Tags',
            published: 'Gepubliceerd',
        },
        count: 'geen artikelen | {n} artikel | {n} artikelen',
        perPage: 'per pagina',
        pageOf: 'Pagina {page} van {pages}',
    },
    status: {
        scheduled: 'Gepland',
        live: 'Live',
    },
    edit: {
        newTitle: 'Nieuw artikel',
        created: 'Artikel aangemaakt',
        confirmDelete: 'Artikel "{title}" verwijderen? Dit kan niet ongedaan worden gemaakt.',
        content: 'Inhoud',
        slugHint: 'URL-segment; wordt uit de titel afgeleid als je het leeg laat',
        excerpt: 'Samenvatting',
        excerptHint: 'Korte samenvatting voor overzichten + metabeschrijving',
        translations: 'Vertalingen',
        defaultLocale: '(standaard)',
        defaultLocaleNote: 'De standaardtaal gebruikt de titel en samenvatting hierboven. Onder Tekst bewerk je de tekst in deze taal.',
        fallbackNote: 'Laat een veld leeg om de tekst in de standaardtaal te gebruiken.',
        body: 'Tekst',
        editingLocale: 'Je bewerkt {locale}. Leeg = de tekst in de standaardtaal.',
        searchEngines: 'Zoekmachines',
        seoIntro: 'Laat een veld leeg voor de standaardwaarde: de titel van het artikel als titel, de samenvatting als metabeschrijving.',
        pageTitle: 'Paginatitel',
        pageTitleHint: 'Getoond op het browsertabblad en als kop in de zoekresultaten',
        metaDescription: 'Metabeschrijving',
        metaDescriptionHint: 'De ideale lengte is 120 tot 158 tekens',
        socialTitle: 'Titel voor social media',
        socialTitleHint: 'Open Graph-titel die wordt gebruikt als het artikel wordt gedeeld',
        socialDescription: 'Omschrijving voor social media',
        advanced: 'Geavanceerd',
        socialImage: 'Afbeelding voor social media',
        socialImageHint: 'Leeg = de uitgelichte afbeelding',
        canonicalOverride: 'Afwijkende canonieke URL',
        robots: 'Robots',
        robotsHintNoindex: 'De website is verborgen voor zoekmachines, dus dit artikel stuurt noindex,nofollow, wat hier ook staat. Wijzig dit onder Website → Algemeen → Zoekmachines.',
        robotsHint: 'Leeg = de standaard van de website (index,follow). Een artikel met noindex blijft ook buiten de sitemap.',
        publishing: 'Publicatie',
        publishingNote: 'Een artikel gaat live als het gepubliceerd is en de publicatiedatum voorbij is. Kies een datum in de toekomst om het in te plannen.',
        publishDate: 'Publicatiedatum',
        author: 'Auteur',
        authorHint: 'Getoond als auteursvermelding',
        access: 'Toegang',
        featuredImage: 'Uitgelichte afbeelding',
        replaceImage: 'Vervangen',
        chooseImage: 'Afbeelding kiezen',
        tags: 'Tags',
        tagPlaceholder: 'Typ een tag en druk op Enter…',
        pickImage: 'Kies of upload een afbeelding',
    },
} satisfies Translation<typeof en>;
